import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AgreementsDateBaseDirective } from '../agreements.base';

@Component({
  selector: 'td-wb-iex-agreement',
  templateUrl: './iex-agreement.component.html',
  styleUrls: ['../agreements.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class IexAgreementComponent extends AgreementsDateBaseDirective {
}
